import React, { FC, useMemo } from 'react'
import cn from 'classnames'

import styles from './Breadcrumbs.module.scss'
import Link from 'next/link'
import { Icon } from '@/icons'

interface BreadcrumbsProps {
  className?: string
  items: { url: string; name: string }[]
  wide?: boolean
}
export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  className,
  items,
  wide = false,
}) => {
  const backLinkIndex = useMemo(() => {
    if (items.length <= 1) {
      return 1
    }

    return items.length - 2
  }, [items.length])

  return (
    <div
      className={cn(styles.container, className, {
        [styles.wide]: wide,
      })}
    >
      {items.length > 1 ? (
        <Icon name="chevronLeft" className={styles.backIcon} />
      ) : null}
      {items.map((link, index, array) => (
        <React.Fragment key={link.url}>
          {index === array.length - 1 ? (
            <span className={cn(styles.item, styles.isLast)}>{link.name}</span>
          ) : (
            <Link
              href={link.url}
              className={cn(styles.item, {
                [styles.backLink]: index === backLinkIndex,
              })}
            >
              {link.name}
            </Link>
          )}
          {array.length - 1 !== index ? (
            <span className={styles.separator}>/</span>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  )
}
